import { LitElement, html, svg } from 'lit';

export class IconBin16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Søppeldunk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 3.5 3 9.25l.46 5.293a.5.5 0 0 0 .498.457h8.084a.5.5 0 0 0 .498-.457L13.5 3.5M9.5 7v4.5M6.5 7v4.5M5 3.5V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1.5M1 3.5h14"></path></svg>`; }
}
if (!customElements.get('f-icon-bin16', IconBin16)) {
  customElements.define('f-icon-bin16', IconBin16);
}